var frc = {
	"buildKey": "{{ GULP_BUILD_KEY }}",
	"data": {
		"user": {
			"geolocation": null,
			"nearestLocation": null,
			"preferredLocation": null,
			"nearestOpenTableLocation": null,
			"currentlyAtStore": false
		}
	},
	"modules": {},
	"pages": {}
};